/** Request headers that ask browsers/proxies not to reuse a cached GET. */
export const NO_STORE_HEADERS: Record<string, string> = {
  'Cache-Control': 'no-cache, no-store, must-revalidate',
  Pragma: 'no-cache',
  Expires: '0',
};

/**
 * Lesson lists, lesson video/file payloads, and quiz questions must always
 * hit the server so teacher edits show up for students.
 */
export function isStudentContentUrl(url = ''): boolean {
  const path = url.toLowerCase();
  return (
    path.includes('contentlesson') ||
    path.includes('tree-course-with-progress') ||
    path.includes('tree-unit-with-progress') ||
    path.includes('/course/tree') ||
    /\/unit\/\d+\/lessons/.test(path) ||
    /\/unit\/standalone\/\d+/.test(path)
  );
}

export function cacheBustParams<T extends Record<string, unknown>>(
  params?: T
): T & { _ts: number } {
  return { ...(params ?? ({} as T)), _ts: Date.now() };
}
